import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css'
import { MobileProvider } from './utils/mobileContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <MobileProvider>
      <App />
    </MobileProvider>
  </React.StrictMode>
);
